import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { CodeBlock } from "./CodeBlock";
import { defaultData } from "./CodeBlockDefaultData";
import { meta } from "./CodeBlockMetaData";

export const CodeBlockExport: BlockExport = {
  type: "component",
  Block: CodeBlock,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-code",
    size: 24,
  },
  defaultData,
  meta,
};
